import { InventoriesView } from "../views/Inventories/InventoriesView";
import { InventoryDetails } from "../views/Inventories/InventoryDetails";
import Deposits_L from "../views/Deposits/lazy";
import { VolumetricInventories } from "../views/VolumetricsInventories/VolumetricInventories";
import VolumetricDetails from "../views/VolumetricsInventories/VolumetricDetails";
import { GenerateXMLView } from "../views/Generate-xml/GenerateXMLView";
import { UploadFromXLSX } from "../views/UploadFrom-xml/UploadFromXLSX";
import { GasMovReportPage } from "../views/gasMovReports/gasMovReportPage";
import { GasMovementsRequests } from "../views/GasMovementsRequests/GasMovementsRequests";
import { WarehousesGraphs } from "views/WarehousesGraphs/WarehousesGraphs";

import AssessmentIcon from "@material-ui/icons/Assessment";
import { PERMISSIONS } from "router/permissions";
import { InventoryDigitalMovementsView } from "views/inventoryDigitalMovements/InventoryDigitalMovementsView";
import { InventoryStatus } from "views/InventoryStatus/InventoryStatus";

const {
  INVENTORIES,
  INVENTORIES_CONTROL,
  INVENTORIES_DEPOSIT,
  INVENTORIES_VOL,
  INVENTORIES_AWS_REAL,
  INVENTORIES_XML,
  INVENTORIES_XML_QUERYZATOR,
  MOVEMENTS_VIEW,
  INVENTORIES_CONTROL_DIGITAL_MOVEMENTS,
  DIGITAL_INVENTORY,
} = PERMISSIONS

export const inventoriesRoutes = [

  {
    collapse: true,
    name: "Inventarios",
    icon: AssessmentIcon,
    state: "inventoriesSection",
    inSidebar: true,
    isProtected: true,
    rule: INVENTORIES,
    views: [
      {
        path: "/control-inventarios",
        name: "Control de Inventarios",
        mini: "CI",
        component: InventoriesView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: INVENTORIES_CONTROL,
      },
      {
        path: "/inventario-detalles/:id",
        name: "Detalle Inventario",
        component: InventoryDetails,
        layout: "/admin",
        inSidebar: false,
        isProtected: true,
        rule: INVENTORIES_CONTROL,
      },
      {
        path: "/depositos",
        name: "Depositos",
        mini: "DP",
        component: Deposits_L,
        layout: "/admin",
        inSidebar: true,
        isProtected: false,
        rule: INVENTORIES_DEPOSIT,
      },
      {
        path: "/inventario-volumetricos",
        name: "Inventario Volumetricos",
        mini: "IV",
        component: VolumetricInventories,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: INVENTORIES_VOL,
      },
      {
        path: "/detalles-volumetricos/:id",
        name: "Detalles Volumetricos",
        sublayout: "/detalles-volumetricos",
        component: VolumetricDetails,
        layout: "/admin",
        inSidebar: false,
        isProtected: true,
        rule: INVENTORIES_VOL,
      },
      {
        path: "/Tiempo_Real",
        name: "Tiempo Real",
        mini: "TR",
        component: WarehousesGraphs,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: INVENTORIES_AWS_REAL,
      },
      {
        path: "/plantilla-xml",
        name: "Generado XML Plantilla",
        mini: "GX",
        component: GenerateXMLView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: INVENTORIES_XML,
      },
      {
        path: "/datos_xlsx",
        name: "Subir Datos Queryzator",
        mini: "SQ",
        component: UploadFromXLSX,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: INVENTORIES_XML_QUERYZATOR,
      },
      {
        path: "/generar_xml",
        name: "Generador XML Queryzator",
        mini: "GQ",
        component: GasMovReportPage,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: INVENTORIES_XML_QUERYZATOR,
      },
      {
        path: "/movimientos-gas",
        name: "Bonificación de Gas",
        mini: "GM",
        component: GasMovementsRequests,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: MOVEMENTS_VIEW,
      },
      {
        path: "/movimientos-inventario-digital",
        name: "Movimientos Inventario Digital",
        mini: "MI",
        component: InventoryDigitalMovementsView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: INVENTORIES_CONTROL_DIGITAL_MOVEMENTS,
      },
      {
        path: "/inventario-digital",
        name: "Inventario Digital",
        mini: "ID",
        component: InventoryStatus,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: DIGITAL_INVENTORY,
      },
    ]
  },
]